import React, { Component} from 'react';
import Clock from 'react-live-clock';

import * as Config from '../config/Config';
import * as User from '../helpers/User';
import * as Common from '../helpers/Common';

export default class Webcastlive extends Component {

  	constructor(props) {
    	super(props);
    	this.compeletestatus="";
    	this.state = {
      	vediocnt:[]
    	};
  	}

    getLivesessiondet(data){
    	Common.reactLoader("show", "Please wait...");
    	fetch(Config.domainUrl+'webcastlive/getlivesessiondetails', {
      	method: 'POST',
          headers: {
        		'Accept': 'application/json',
        		'Content-Type': 'application/json',
				'Authorization':'Bearer ' +Common.getTokenData()
          },
          body: JSON.stringify({data,learner_id: User.UserId()})
    	}).then((response) => response.json()).then((responseJson) => {
        	this.setState({
        		vediocnt:responseJson
        	});
        	setTimeout(()=>{
            Common.contentResizeLoad();
          	Common.showSmallLeftMenu();
        		Common.contentResizeLoad();
        		Common.reactLoader("hide");
          }, 200);
    	});
    }

  	componentDidMount() {
    	const {data}=this.props;
    	this.compeletestatus = data.status;
    	this.getLivesessiondet(data);
      setInterval(()=>{ this.getLivesessiondet(data); },55000);
  	}

  	componentWillReceiveProps(nextProps) {
  		const {data}=nextProps;
    	this.compeletestatus = data.status;
    	setTimeout(()=>{
	  		this.getLivesessiondet(data);
    	},300);
  	}

    golivesession(durl){
      if(durl!=null){
        window.open(durl, '_blank');
      }
    }

    backToComponentList(){
  		const {data}=this.props;
  		this.props.switchback('component_list',data.learning_room_id,data.dlr_id);
    }

  	render() {
    	let vdata=this.state.vediocnt;
  		return (
		  <div className="main-inner">
    		<div className="border-box">
    			<div className="title-box tit-new">
      			<div title="Recorded Session" className="vc_active_button"></div>
      		  	<h6>Live Session</h6> <span></span>
            </div>
    			<section className="scrol" id="smana-scroll-inner">
          			<section className="viewport">
          				<section className="overview">
                  			<div className="inner-content">
      							<div className="wc_contbg">
          							<div className="cont_left">
          								<h3 className="blue-txt">Live session scheduled for: </h3>
          								<span className="txt_bold">
          									<Clock date={vdata.scheduled_start_date} format={'DD-MMM-YYYY, hh:mm a'} /> to <Clock date={vdata.scheduled_end_date} format={'hh:mm a'}/> IST
          								</span>
        							</div>
        							<div className="cont_dright">
        								<h3 className="blue-txt">Current Date and time: </h3>
        								<span className="txt_bold">
        									<Clock format={'DD-MMM-YYYY hh:mm:ss a'} ticking={true} /> IST
    									</span>
    								</div>
								</div>
                {vdata.session_status==='join' && <div align="center" className="btn_jw">
									  <div id="ShowButton">
		  					  			<input name="btnsubmit" value="Join the live session" alt="Join the live session" title="Join the live session" type="button" onClick={e=>this.golivesession(vdata.live_session_url)} />
			  						</div>
		  						</div>
                }
                {vdata.session_status==='expired' &&	<div align="center" id="ShowButtonExpired">
				{(this.props.usableType==="webapp")?<div id="ShowButton">
		  					  			<input name="btnsubmit" value="Session Lost Go to home" alt="Session Lost Go to home" title="Session Lost Go to home" type="button" onClick={e=>this.backToComponentList()} />
			  						</div>:""}
                				</div>
                }
                {vdata.session_status==='missed' && <div align="center" id="ShowMissed">
									<font><b>Sorry, you have missed the live session.</b></font><br/>
									<font>
										You will be intimated as soon as the recorded session is available for scheduling. <br/>
										You may go back to the Learning Room for now.
									</font>
								</div>
              }

								<div className="note_gray">
									<span className="greentxt">Note :</span> Please make sure you have the following, before you view the session:
						        	<ul className="blist" >
					            		<ol>1. Internet speed of 512 kbps and higher. </ol>
										  <ol>2. Flash player 10 plugin installed in your browser. To upgrade your Flash player, please <a href="http://get.adobe.com/flashplayer/" target="_blank" rel="noopener noreferrer">click here</a>.</ol>
										  <ol>3. Headphones plugged in your computer. Check your headphones functioning by clicking on the play button.  
											<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=7,0,19,0" width="60" height="17">
								                <param name="movie" value="media/click_test.swf" />
								                <param name="quality" value="high" />
								                <embed src="media/click_test.swf" quality="high" pluginspage="http://www.macromedia.com/go/getflashplayer" type="application/x-shockwave-flash" width="60" height="17"></embed>
								    		</object>
								    	</ol>
								 	</ul>
					    			<div className="webcastbg">
										Best viewed at 1024x768 screen resolution using Firefox 2+, Internet Explorer 7+, Opera 9.6, Chrome 2+ or Safari 4 browsers.
									</div>
						    	</div>
        					</div>
                  		</section>
  				  	</section>
    			</section>
      		</div>
		</div>
    	);
  	}
}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/Webcastlive.js